import script from "./CardGroup.vue?vue&type=script&lang=ts&setup=true"
export * from "./CardGroup.vue?vue&type=script&lang=ts&setup=true"

import "./CardGroup.vue?vue&type=style&index=0&id=3fbdafec&lang=less&scoped=true"

import exportComponent from "/home/www-fe/fe-prod/workspace/talbook_bfe_h5_base_frame_refs-heads-master/source_code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fbdafec"]])

export default __exports__